import React from 'react';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template">
        <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: 'Equinix IaaS Platform'})}</h1>
        <p>{formatMessage({id: 'notAuthorized.eqxIaas.description'})}</p>
        <ul>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option1'})}</li>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option2'})}</li>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option3'})}</li>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option4'})}</li>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option5'})}</li>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option6'})}</li>
            <li>{formatMessage({id: 'notAuthorized.eqxIaas.option7'})}</li>
            <li>
                {formatMessage({id: 'notAuthorized.eqxIaas.option8'})}
                <ul>
                    <li>{formatMessage({id: 'notAuthorized.eqxIaas.option8.option1'})}</li>
                    <li>{formatMessage({id: 'notAuthorized.eqxIaas.option8.option2'})}</li>
                    <li>{formatMessage({id: 'notAuthorized.eqxIaas.option8.option3'})}</li>
                    <li>{formatMessage({id: 'notAuthorized.eqxIaas.option8.option4'})}</li>
                    <li>{formatMessage({id: 'notAuthorized.eqxIaas.option8.option5'})}</li>
                </ul>
            </li>
        </ul>
        <div className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </div>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/eqxIaas.js